import React from 'react'
import Wrapper from './style'

const SchGap = ({height, width}) => {
	return (
		<Wrapper
		 	height={height}
			width={width}
		>
		</Wrapper>
	)
}

export default SchGap
